import { Fragment, ReactElement } from 'react';
import CancellationNonResidentNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-death-non-resident/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const CancellationNonResidentNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <CancellationNonResidentNotificationCivilStatusShared scope={IdAmbito.Cancellazioni} />
    </Fragment>
  );
};

CancellationNonResidentNotificationCivilStatusPage.displayName =
  'Research Death Detail Notifications Page component';

export default CancellationNonResidentNotificationCivilStatusPage;
